import { createFileRoute } from "@tanstack/react-router";
import { signInRedirect } from "~/lib/server-auth.ts";

/**
 * Legacy sign-in path.
 *
 * The canonical login now lives per-brand at `/<brand>/login`. This route is
 * kept only as a back-compat redirect for old `/auth/sign-in` links and
 * bookmarks. It forwards to the **brand login for the request host** (resolved
 * server-side from the host via {@link signInRedirect}), so the legacy path
 * lands on a login that resolves on the current host — `/clawinstall/login` on
 * clawinstall, `/orca/login` on the orca host, `/flirtmachine/login` elsewhere.
 * A hardcoded `/flirtmachine/login` here used to 404 on the orca host because
 * the orca wildcard rewrite turns it into `/orca/flirtmachine/login`.
 *
 * Unauthenticated users no longer reach here via guards — the brand-aware
 * `requireAuth` sends them straight to the correct brand login.
 *
 * @since 1.0.0
 */
export const Route = createFileRoute("/auth/sign-in/")({
  // oxlint-disable-next-line eslint-js/no-restricted-syntax -- TanStack redirects require async/await, not Effect
  beforeLoad: async () => {
    // oxlint-disable-next-line eslint-js/no-restricted-syntax -- server fn throws the host-aware redirect
    await signInRedirect();
  },
});
